// extracted by mini-css-extract-plugin
export default {"title":"HotelAirportDetails_title__A3C7Q","total":"HotelAirportDetails_total__ptDgG","edit":"HotelAirportDetails_edit__15tvr"};